'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @file 直接加载视频类
 * @author zhangzhe(zhangzhe@baidu.com)
 */

define(['api/global-api', 'utils/underscore'], function (GlobalApi, _) {

    // 只有这些字段的输入可能是json格式
    var jsonKeyArr = ['imageAdvs', 'playlist', 'listbar', 'tracks', 'captions', 'controlbar', 'logo', 'skin', 'marquee'];

    function getParams(scriptSrc) {
        var param = {};
        var argsArr = scriptSrc.substr(scriptSrc.indexOf('?') + 1).split('&');
        for (var j = 0; j < argsArr.length; j++) {
            var args = argsArr[j];
            var index = args.indexOf('=');
            if (index > -1) {
                var argKey = args.substr(0, index);
                var argValue = decodeURIComponent(args.substr(index + 1));
                if (_.contains(jsonKeyArr, argKey)) {
                    // 这里把单引号改成双引号为了兼容用户输入json对象不规范问题
                    argValue = argValue.replace(/'/g, '"');
                    if ((typeof JSON === 'undefined' ? 'undefined' : _typeof(JSON)) === 'object' && typeof JSON.parse === 'function') {
                        argValue = JSON.parse(argValue);
                    } else {
                        /* jshint ignore:start */
                        /* eslint-disable */
                        argValue = eval('(' + argValue + ')'); // 为了支持IE8兼容版本
                        /* eslint-enable */
                        /* jshint ignore:end */
                    }
                }
                param[argKey] = argValue;
            }
        }
        return param;
    }

    // 如果js在一个div下面，则此时需要加载播放器
    function loadPlayer() {
        var scripts = document.getElementsByTagName('script');
        var scriptLen = scripts.length;
        while (scriptLen--) {
            var script = scripts[scriptLen];
            var scriptSrc = script.src;
            if (scriptSrc.indexOf('cyberplayer.js') > -1) {
                var param = getParams(scriptSrc);
                // 参数大于3个才认为用这种方式加载
                if (_.size(param) > 3 && script.parentNode.nodeName === 'DIV') {
                    return GlobalApi.selectPlayer(script.parentNode).setup(param);
                }
            }
        }
    }

    loadPlayer();

    return {
        getParams: getParams,
        loadPlayer: loadPlayer
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/baidu/load-player.js
 ** module id = 219
 ** module chunks = 0
 **/